<template>
  <pano-info-spot
      class="panorama-spot"
      label=""
      :position="position"
      v-if="isShow"
  >
    <template v-if="type === 'info'">
      <panorama-ui-point
      :style="bgColor"
      :hint="label"
      :opened="opened"
      :is-show="isShow"
      slot="dotElement"
      >
        <panorama-spot-icon :icon="icon" />
      </panorama-ui-point>
    </template>
    <template v-if="type === 'corps'">
      <panorama-build-spot :corps="label" slot="dotElement"/>
    </template>
    <template v-if="type === 'label'">
      <panorama-road-spot :name="label" slot="dotElement"/>
    </template>
  </pano-info-spot>
</template>

<script>
import PanoramaUiPoint from '@/components/spots/PanoramaPointSpot'
import PanoramaSpotIcon from '@/components/elements/PanoramaSpotIcon'
import PanoramaRoadSpot from '@/components/elements/PanoramaRoadSpot'
import PanoramaBuildSpot from '@/components/spots/PanoramaBuildSpot'
export default {
  name: 'PanoramaSpot',
  components: {
    PanoramaBuildSpot,
    PanoramaSpotIcon,
    PanoramaUiPoint,
    PanoramaRoadSpot
  },
  props: {
    position: {
      type: Object,
      default: () => ({ x: 1, y: 1 })
    },
    label: String,
    icon: String,
    backgroundColor: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'info'
    },
    opened: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    bgColor () {
      if (this.backgroundColor) {
        return '--panorama-background-color: ' + this.backgroundColor
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
